<mat-card>
  <app-card-header
    [title]="title"
    icono="label"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Content -->
      <mat-card-content class="card-content-crear">
        <section class="inputs-group">
          <!-- Nombre -->
          <mat-form-field style="flex: 2">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" />
          </mat-form-field>
          <!-- Prioridad -->
          <mat-form-field style="flex: 1">
            <mat-label>Prioridad</mat-label>
            <input matInput formControlName="prioridad" type="number" />
          </mat-form-field>
        </section>
        <section class="inputs-group">
          <!-- Color -->
          <mat-form-field style="flex: 1">
            <mat-label>Color</mat-label>
            <input matInput readonly formControlName="color" />
            <ngx-colors
              class="suffix"
              matSuffix
              ngx-colors-trigger
              formControlName="color"
            ></ngx-colors>
          </mat-form-field>
          <!-- Sonido -->
          <ng-select
            [items]="sonidos"
            formControlName="sonido"
            placeholder="Sonido"
            appendTo="body"
            notFoundText="Sin resultados"
            style="flex: 1"
          ></ng-select>
        </section>
        <section class="inputs-group">
          <!-- Módulo -->
          <ng-select
            [items]="modulos"
            formControlName="modulo"
            placeholder="Módulo"
            appendTo="body"
            notFoundText="Sin resultados"
            style="width: 100%"
          ></ng-select>
        </section>
        <!-- Checkbox -->
        <div class="row-center">
          <!-- Notificar -->
          <div style="margin: 1em">
            <mat-label>Notificación Push</mat-label>
            <mat-checkbox
              color="primary"
              formControlName="notificar"
            ></mat-checkbox>
          </div>
          <!-- Atender -->
          <div style="margin: 1em">
            <mat-label>Requiere Atención</mat-label>
            <mat-checkbox
              color="primary"
              formControlName="atender"
            ></mat-checkbox>
          </div>
          <!-- No derivar -->
          <div style="margin: 1em">
            <mat-label>No Derivar</mat-label>
            <mat-checkbox
              color="primary"
              formControlName="noDerivar"
            ></mat-checkbox>
          </div>
          <!-- Global -->
          @if (helper.esNivel0()) {
            <div style="margin: 1em">
              <mat-label>Global</mat-label>
              <mat-checkbox
                color="primary"
                formControlName="global"
              ></mat-checkbox>
            </div>
          }
          <!-- Default -->
          @if (helper.esNivel0()) {
            <div style="margin: 1em">
              <mat-label>Default</mat-label>
              <mat-checkbox
                color="primary"
                formControlName="default"
              ></mat-checkbox>
            </div>
          }
        </div>
      </mat-card-content>
      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="dialogRef.close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  }

  <mat-progress-bar
    color="primary"
    [mode]="loading ? 'indeterminate' : 'determinate'"
  ></mat-progress-bar>
</mat-card>
